const { FIRST_PARTY_HOSTS, POSTHOG_PROXY_PATH } = require("../config/analytics")

const isFirstPartyHost = () =>
  typeof window !== "undefined" &&
  FIRST_PARTY_HOSTS.includes(window.location.hostname)

/** PostHog ingestion host: our own /k7 proxy on klang.ai, PostHog EU elsewhere. */
export const posthogApiHost = () =>
  isFirstPartyHost()
    ? `${window.location.origin}${POSTHOG_PROXY_PATH}`
    : "https://eu.i.posthog.com"
